import React from 'react';
import { constants } from '../../Constants';
import Select from 'react-select';
import 'react-day-picker/lib/style.css';
import { editApptTime } from '../../helpers/ConstantID';
export default function EditAppointmentModal(props) {
    const { selectNatureOfIssue, closeModalHandler, handleNatureIssueChange, appointment_id, submitIssueNature, value, isOtherSelected, handleOtherInputChange, natureIssueOther } = props;

    return (
        <React.Fragment>
            <div className="nature-modal">
                <div
                    className="modal-react counsellor-apt-modal update-nature-issue-modal"
                    id="modal"
                    tabIndex={0}
                    onBlur={props.onEditModalClose}
                >

                    <span onClick={() => closeModalHandler(true)} className="close-button topright nature-close-btn">
                        <i className="fa fa-times" aria-hidden="true"></i>
                    </span>
                    <h2 className="nature-modal-title">{constants.SELECT_NATURE_OF_ISSUE_TXT}</h2>
                    <div
                        className="table borderless table-responsive w-100 d-block d-md-table"
                    >
                        <div
                            className="mt-2 text-center nature-table-body"
                        >


                            <div className="nature-select">
                                <Select
                                    name="natureOfIssues"
                                    isMulti
                                    options={selectNatureOfIssue}
                                    onChange={(e, action) => handleNatureIssueChange(e, action)}
                                    value={value}
                                />
                            </div>
                            {isOtherSelected && <div className='nature-select'>
                                <input className='form-control sh-nature-input mb-3'
                                    onChange={e => handleOtherInputChange({ value: e.target.value, label: "other" })}
                                    name="natureOfIssues"
                                    value={natureIssueOther}
                                />
                            </div>}
                        </div>
                        <div className="sh-btn-box">
                            <button id={editApptTime.sh_cl_edit_cancel} className="sh-gnrl-btn sh-gnrl-cancel-btn" onClick={() => closeModalHandler(true)}>
                                {constants.CANCEL_TXT}
                            </button>
                            <button
                                id={editApptTime.sh_cl_edit_submit}
                                type="button"
                                className="sh-gnrl-btn sh-gnrl-sumit-btn"
                                onClick={() => submitIssueNature(appointment_id)}
                            >
                                {constants.SUBMIT_TEXT}
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/components/UpdateNatureOfIssueModal/index.js